import React from 'react';

import TitleBar from 'shared/migration-components/title-bar';

import {Container} from './styles';
import Tabs, {TabProps} from 'shared/migration-components/tabs';
import {EditCity, Distances, Neighborhoods, AccessControls} from './components';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import BillingRecorency from './components/billing-recorency';

interface Props {
  activeTab?: string;
}

const CityDetails: React.FC<Props> = ({activeTab}) => {
  const {isAllowed, cityId} = useAccessControls();

  const tabs: TabProps[] = [
    {
      label: 'Editar cidade',
      content: <EditCity />,
      hidden: !isAllowed('cities.findOne'),
    },
    {
      tab: 'neighborhoods',
      label: 'Bairros',
      content: <Neighborhoods />,
      hidden: !isAllowed('cities.findOne'),
      createUrl: 'create',
    },
    {
      tab: 'distances',
      label: 'Distâncias',
      content: <Distances />,
      hidden: !isAllowed('cities.findOne'),
      createUrl: 'create',
    },
    {
      tab: 'access-controls',
      label: 'Controle de acesso',
      content: <AccessControls />,
      createUrl: 'create',
    },
    {
      tab: 'billing-recorency',
      label: 'Fechamentos',
      content: <BillingRecorency />,
      createUrl: 'create',
    },
  ];

  return (
    <Container>
      <TitleBar
        title="Detalhes da cidade"
        backUrl={cityId ? undefined : '/settings/cities'}
      />
      <Tabs {...{activeTab, tabs}} />
    </Container>
  );
};

export default CityDetails;
